import type { TPrintBookFont } from '@/types/print-books'

export const documentFonts: TPrintBookFont[] = [
  {
    id: 0,
    name: 'Old Warm Charm',
    description: 'The default system font used by the editor. Clean, neutral, and highly readable.',
    titleFont: 'Nunito Sans',
    bodyFont: 'Libre Baskerville',
  },
  {
    id: 1,
    name: 'Timeless Elegance',
    description: 'A perfect harmony of classic charm and modern readability - ideal for novels or memoirs.',
    titleFont: 'Playfair Display',
    bodyFont: 'Merriweather',
  },
  {
    id: 2,
    name: 'Literary Soul',
    description: 'Warm, elegant, and deeply bookish - designed for readers who love beautiful pages.',
    titleFont: 'Cormorant',
    bodyFont: 'Lora',
  },
  {
    id: 3,
    name: 'Old World Charm',
    description: 'Traditional yet balanced - a refined duo for professional or historical works.',
    titleFont: 'Libre Baskerville',
    bodyFont: 'Crimson Pro',
  },
  {
    id: 4,
    name: 'Scholarly Grace',
    description: 'Serious and sophisticated, a confident choice for essays, studies, or biographies.',
    titleFont: 'EB Garamond',
    bodyFont: 'Spectral',
  },
  {
    id: 5,
    name: 'Modern Heritage',
    description: 'Classic shapes with a modern twist - perfect for business or nonfiction titles.',
    titleFont: 'PT Serif Caption',
    bodyFont: 'Source Serif Pro',
  },
  {
    id: 6,
    name: 'Clean Thought',
    description: 'Fresh, clear, and structured, ideal for modern nonfiction and tech-focused books.',
    titleFont: 'Poppins',
    bodyFont: 'Noto Serif',
  },
  {
    id: 7,
    name: 'Urban Classic',
    description: 'Elegant yet energetic - fits perfectly for guides, magazines, and lifestyle books.',
    titleFont: 'Montserrat',
    bodyFont: 'Domine',
  },
  {
    id: 8,
    name: 'Tech Poise',
    description: 'A professional, unified family - made for analytical, tech, or design publications.',
    titleFont: 'IBM Plex Sans',
    bodyFont: 'IBM Plex Serif',
  },
  {
    id: 9,
    name: "Storyteller's Touch",
    description: 'Soft and humanistic - for stories that feel personal and timeless.',
    titleFont: 'Alegreya',
    bodyFont: 'Cardo',
  },
  {
    id: 10,
    name: 'Gentle Voice',
    description: 'Light, graceful, and balanced - perfect for romance, essays, or inspirational reads.',
    titleFont: 'Raleway',
    bodyFont: 'Literata',
  },
]
